export const en = {
    'copy-link': 'Copy list of criteria',
    ots: 'OTS',
    'predictor-error': 'The forecast is temporarily unavailable',
    'predictor-seven-days': 'Estimate reach for 7 days',
    reach: 'Reach'
};
